import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import Button from '../../../components/Button/Button';

import { useFieldContext, useFormContext } from '../../form';

const HeadersField = ({ disabled, testId }) => {
  const { t } = useTranslation();
  const field = useFieldContext();
  const form = useFormContext();

  const removeValue = useCallback(
    (idx) => {
      field.removeValue(idx);
      field.handleBlur();
    },
    [field],
  );

  const addValue = useCallback(() => {
    field.pushValue({ header_name: '', header_value: '' });
    field.handleBlur();
  }, [field]);

  return (
    <div {...getTestProps(testId, `container`)}>
      {field.state.value?.map((_, index) => (
        <form.AppField key={index} name={`headers[${index}]`}>
          {(field) => (
            <field.HeaderField
              onRemove={removeValue}
              index={index}
              disabled={disabled}
              testId={testId}
            />
          )}
        </form.AppField>
      ))}

      <Button
        buttonSize="sm"
        additionalClasses="w-max mb-4"
        additionalChildrenClasses="flex flex-row items-center"
        onClick={addValue}
        disabled={disabled}
        {...getTestProps(testId, `button-add`, 'testId')}
      >
        {t('Webhooks.AddHeader')}
      </Button>
    </div>
  );
};
export default HeadersField;
